var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-cascader',{attrs:{"options":_vm.serviceTypeOption,"props":{ checkStrictly: false,multiple:true, },"max-collapse-tags":1,"collapse-tags":"","collapse-tags-tooltip":"","clearable":true,"show-all-levels":false},on:{"change":_vm.serviceTypeHandleChange,"clear":function () {
                 this$1.$emit('selectedCategoryType', []);
                 this$1.targetServer = [];
               }},model:{value:(_vm.categoryTypeId),callback:function ($$v) {_vm.categoryTypeId=$$v},expression:"categoryTypeId"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }